import { BaseTextFieldProps } from '@mui/material'
import { useField } from 'formik'
import theme from 'lib/theme'
import { ReactNode } from 'react'
import { StyledInput } from './Input.styled'

interface InputProps extends BaseTextFieldProps {
  label?: string | ReactNode
  name: string
  type: string
  marginBottom?: string
  startAdornment?: ReactNode
  width?: string
  errorMessage?: string
  placeHolder?: string
  autoFocus?: boolean
  multiline?: boolean
  rows?: number
  flexBasis?: string
  dependentValidation?: boolean
}

const Input = ({
  errorMessage,
  marginBottom,
  width,
  autoFocus,
  multiline,
  rows,
  startAdornment,
  flexBasis,
  dependentValidation,
  ...props
}: InputProps) => {
  const [field, meta] = useField(props.name)
  const hasError = Boolean((meta.touched || dependentValidation) && meta.error)

  return (
    <StyledInput
      {...field}
      {...props}
      multiline={multiline}
      rows={rows}
      mb={marginBottom || theme.spacing(6)}
      autoFocus={autoFocus}
      variant='filled'
      error={hasError}
      helperText={hasError ? errorMessage : null}
      InputLabelProps={{ shrink: true }}
      disabled={Boolean(props.disabled)}
      width={width as string}
      flexBasis={flexBasis}
      InputProps={{ startAdornment }}
    />
  )
}

export default Input
